/**
 * 字数统计工具 — 与后端 app/utils/word_count.py 保持一致
 */

/** 统计文本字数（中文字符数 + 英文单词数），去除 Markdown/HTML 标记 */
export function countWordsInText(text: string): number {
  if (!text) return 0;

  // 先去除 HTML 标签
  let cleaned = text.replace(/<[^>]*>/g, '').replace(/<!--[\s\S]*?-->/g, '');

  // 去除 Markdown 格式标记（与后端一致）
  cleaned = cleaned.replace(/^#+\s*/gm, '');
  cleaned = cleaned.replace(/\*\*([^*]+)\*\*/g, '$1');
  cleaned = cleaned.replace(/\*([^*]+)\*/g, '$1');
  cleaned = cleaned.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
  cleaned = cleaned.replace(/```[\s\S]*?```/g, '');
  cleaned = cleaned.replace(/`([^`]+)`/g, '$1');
  cleaned = cleaned.replace(/^[\s]*[-*+]\s+/gm, '');
  cleaned = cleaned.replace(/\|/g, ' ');
  cleaned = cleaned.replace(/\s+/g, ' ');

  // 统计中文字符（含中文标点在 Unicode 范围内的部分）
  const chineseChars = (cleaned.match(/[\u4e00-\u9fff]/g) || []).length;

  // 统计英文单词
  const englishWords = (cleaned.match(/\b[a-zA-Z]+\b/g) || []).length;

  return chineseChars + englishWords;
}
